module.exports = __webpack_public_path__ + "img/48.546c5b36.jpg";